import { render, staticRenderFns } from "./ServiceProviderList.vue?vue&type=template&id=9a2b2194&scoped=true&"
import script from "./ServiceProviderList.vue?vue&type=script&lang=ts&"
export * from "./ServiceProviderList.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceProviderList.vue?vue&type=style&index=0&id=9a2b2194&prod&scoped=true&lang=css&"
import style1 from "./ServiceProviderList.vue?vue&type=style&index=1&id=9a2b2194&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2b2194",
  null
  
)

export default component.exports